import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './star-rating.component.html',
  styleUrl: './star-rating.component.scss'
})
export class StarRatingComponent {
  @Input() stars = 5;
  @Input() rating = 0;
  @Output() ratingChange = new EventEmitter<number>();
  hovered = 0;
  hasInteracted = false;
  setRating(value: number) {
    this.rating = value;
    this.hasInteracted = true;
    this.ratingChange.emit(this.rating);
  }

  setHover(value: number) {
    this.hovered = value;
  }

  clearHover() {
    this.hovered = 0;
  }
  
  getColor(index: number) {
    if (!this.hasInteracted) {
      return '#D9D9D9';
    }
    return index < this.rating ? 'gold' : '#D9D9D9';
  }
}